import React from 'react';

import { PageHeader } from 'antd';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import StationGroupConfigForm from '../organisms/StationGroupConfigForm';

const StationCreatePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const StationCreatePage = () => {
  const history = useHistory();
  const initialValues = {
    chargeBoxGroupPk: '',
    name: '',
    status: true,
    address: {
      street: '',
      houseNumber: '',
      zipCode: '',
      city: '',
      state: '',
      country: 'BR',
    },
    locationLatitude: '',
    locationLongitude: '',
    externalId: null,
  };

  return (
    <StationCreatePageWrapper>
      <PageHeader className='site-page-header' onBack={() => history.goBack()} title={T('Creating Chargebox Group')} />
      <StationGroupConfigForm initialValues={initialValues} type='create' />
    </StationCreatePageWrapper>
  );
};

export default StationCreatePage;
